import { useMutation } from '@tanstack/react-query';
import { AuthContext } from '@urbanx/agx.auth.client';
import { GetMetricsRequest } from '@urbanx/agx.rex.client';
import { useCallback, useContext } from 'react';
import RexService from 'services/rexService';

const useExportNetworkItemizedTransactions = () => {
  const { getAuthToken } = useContext(AuthContext);

  const exportNetworkItemizedTransactions = useCallback(
    async (request: GetMetricsRequest) => {
      const token = await getAuthToken();
      const service = new RexService(token);

      return service.rexService.post(
        'ExportNetworkItemizedTransactions',
        request,
        {},
        {},
        undefined,
        { responseType: 'blob' }
      );
    },
    [getAuthToken]
  );

  const { mutateAsync, isPending: exportNetworkItemizedTransactionsPending } = useMutation({
    mutationFn: exportNetworkItemizedTransactions,
  });

  return {
    exportNetworkItemizedTransactions: mutateAsync,
    exportNetworkItemizedTransactionsPending,
  };
};

export default useExportNetworkItemizedTransactions;
